module.exports = __webpack_public_path__ + "static/media/Source Info - daedam9.72304f90.txt";